<template>
  <div>
    <NavTop class="navbar">
      <template v-slot:mainnavlist>
        <!--        <div @click="routerpush('/home')">首页</div>-->
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            学校概括<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item>
              <div @click="navigateTo('/profiles')">学校简介</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="navigateTo('/leader')">现任领导</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="navigateTo('/nav')">校园导航</div>
            </el-dropdown-item>
            <el-dropdown-item>VR全景校园</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="navigateTo('/institution')">机构设置</div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            党建原地<i class=" "></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item>
              <div @click="navigateTo('/partyActive')">党建活动</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="navigateTo('/partySystem')">相关制度</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="navigateTo('/')">教师研修</div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            招生就业<i class=" "></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item>招生信息</el-dropdown-item>
            <el-dropdown-item>就业信息</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="navigateTo('/')">人才培养</div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link">
            走进东方<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item>
              <div @click="navigateTo('/life')">校园生活</div>
            </el-dropdown-item>
            <el-dropdown-item>
              <div @click="navigateTo('/schoolStyle')">校园风采</div>
            </el-dropdown-item>

          </el-dropdown-menu>
        </el-dropdown>
        <div class="nav" @click="navigateTo('/')">学生服务</div>
      </template>
    </NavTop>
    <!-- 轮播图 -->
    <div class="block">
      <el-carousel trigger="click" height="450px">
        <el-carousel-item v-for="item in 4" :key="item" :interval='5000'>
          <h3 class="small">{{ item }}</h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="center" ref="targetDiv">
      <div class="left_box">
        <!-- 左侧导航框 -->
        <aside class="sidebar">
          <div class="left_title">
            <div>
              学校概括
            </div>
            <div>
              ABOUT CUEB
            </div>
          </div>
          <ul class="left_nav">
            <li v-for="(item, index) in navItems" :key="index" @click="navigateTo(item.path)">
              {{ item.name }}
            </li>
          </ul>
        </aside>
      </div>
      <div class="right_box">
        <div class="row between border_bottom" >
          <div class="title"><h3>学院导航</h3></div>
          <div class="right_link">
            <router-link to="/" class="link">首页</router-link>
            /
            <router-link to="/profiles" class="link">学校概况</router-link>
            /
            <router-link class="link" to="/nav">学院导航</router-link>
          </div>
        </div>
        <!-- 地图 -->
        <div class="mapContainer">
          <Map></Map>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavTop from '../../components/comcomponents/NavTop.vue'
import Map from '../../components/Map/Map.vue'
export default {
  components: {NavTop,Map},
  data () {
    return {
      navItems: [
        {name: '首页', path: '/home'},
        {name: '学校简介', path: '/profiles'},
        {name: '现任领导', path: '/leader'},
        {name: '学院导航', path: '/nav'},
        {name: 'VR校园全景', path: '/vr'}

      ]
    }
  },
  mounted () {
    this.scrollToDiv()
  },
  methods: {
    navigateTo (path) {
      this.$router.push(path)
    },
    scrollToDiv () {
      // 使用 $refs 访问目标 div 元素
      const targetElement = this.$refs.targetDiv
      if (targetElement) {
        // 使用 window.scrollTo() 方法平滑滚动到 div
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: 'smooth'
        })
      }
    }
  }

}
</script>

<style lang="less">
.link {
  text-decoration: none;
  color: #333;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}

.dropdown_menu {
  transform: translate(0, -6%);
  width: 120px;

  .el-dropdown-menu__item {
    text-align: center;
  }

  .el-dropdown-menu__item:hover {
    background-color: #8d080e;
    color: #fff;
  }
}

.dropdown {

}

.dropdown:hover {
  background-color: #9e070e;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
  height: 450px;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.center {
  margin: 0 auto;
  width: 1240px;
  display: flex;
  flex-direction: row;
}

.sidebar {
  text-align: center;
  width: 200px;
  height: 100vh;
  margin-right: 50px;
}

.sidebar h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

.sidebar .left_nav {
  //background-color: #fafafa;
  transform: translateY(-40%);
  list-style: none;
  padding-bottom: 100px;
  background: linear-gradient(170deg, #fafafa 90%, #fff 10%);

}

.sidebar .left_nav li {
  cursor: pointer;
  margin-bottom: 5px;
  font-size: 16px;
  padding: 10px;
  transition: background-color 0.3s;
}

.sidebar .left_nav li:hover {
  color: #6a6a6a;
  background-color: #eee;
}

.content-section h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.content-section p {
  font-size: 16px;
  line-height: 1.6;
  color: #555;
}

.right_box {
  width: 100%;
  .mapContainer{
    margin: 0 auto;
    transform: scale(0.9);
    width: 800px;
    height: 600px;
   &:hover{
     cursor: pointer;
   }
  }
}

.title {
  width: 150px;
  height: 50px;
  padding-top: 10px;
  border-bottom: 3px solid #9e070e;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.between {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.border_bottom {
  border-bottom: 1px solid #cdcbcc;
}

.left_box {
  display: flex;
}

.left_title {
  background: linear-gradient(-170deg, #9e070e 50%, #fafafa 10%);
  height: 350px;
  padding: 40px 0 0 0;
  color: #FFFFFF;

  div:first-child {
    font-size: 30px;
    margin: 10px;
  }

  div:last-child {
    font-size: 15px;
  }
}

.right_link {
  color: #666;
  font-size: 14px;

}

.txt {
  padding: 40px 0;
  text-indent: 2em;
  line-height: 2em;

}
</style>



// WEBPACK FOOTER //
// src/views/Nav/index.vue